module.exports = __webpack_public_path__ + "static/media/home-icon.143559d8.svg";